import { get, post } from "../xhr";

export function createProceeding(data) {
    const id = data.caseId;
    delete data.caseId;
    return post(`/proceeding/create/${id}`, 'application/json', data)
}

export function rescheduleProceeding(data) {
    return post('/proceeding/reschedule', 'application/json', data)
}

export function getProceedings () {
    return get('/proceeding/up-coming', 'application/json');
}

export function proceedings(page = 1) {
    return get(`/proceeding/?page=${page}`, 'application/json');
}